(() => {
  const config = document.getElementById('inbodega-form-label-config');
  const main = document.querySelector('main');
  if (!config || !main) return;
  const names = config.dataset;
  const mappings = { 'First name': names.firstName, 'Enter your email': names.email, 'Your phone number': names.phone, 'Your company name': names.company, 'Your city': names.city };
  let counter = 0;
  const apply = () => {
    main.querySelectorAll('input, select').forEach(field => {
      if (field.dataset.inbodegaLabeled || field.type === 'hidden') return;
      const labelText = (field.type === 'date' ? names.eventDate : mappings[field.getAttribute('placeholder')]) || (field.tagName === 'SELECT' && !(field.labels && Array.from(field.labels).some(label => label.textContent.trim())) ? names.country : null);
      if (!labelText) return;
      field.dataset.inbodegaLabeled = 'true';
      field.setAttribute('aria-label', labelText);
      const existing = field.labels && Array.from(field.labels).find(label => label.textContent.trim());
      if (existing || field.tagName === 'SELECT' || field.type === 'date') return;
      if (!field.id) field.id = `inbodega-event-field-${++counter}`;
      const label = document.createElement('label');
      label.htmlFor = field.id;
      label.textContent = labelText;
      label.style.cssText = 'display:block;font-size:14px;line-height:1.5;margin:0 0 4px;font-weight:500;color:inherit';
      field.parentNode.insertBefore(label, field);
    });
  };
  apply();
  new MutationObserver(apply).observe(main, { childList: true, subtree: true });
})();
